module.exports = __webpack_public_path__ + "img/chevoron.7db33f33.svg";